import LabResults from './LabResults';

export default LabResults;
